module.exports = __webpack_public_path__ + "static/media/Clothing.b2e96775.jpg";